import { gql } from '@apollo/client';

export const GET_DAILY_ALERT_DASHBOARD = gql`
    query GetDailyAlertDashboard($limit: Int, $date: Date) {
        getDailyAlertDashboard(limit: $limit, date: $date) {
            date
            periodStart
            periodEnd
            stats {
                companiesToday
                companiesTotal
                talentsToday
                talentsTotal
                jobOffersToday
                jobOffersTotal
                applicationsToday
                applicationsTotal
            }
            offerBreakdown {
                classicToday
                premiumToday
            }
            applicationBreakdown {
                classicToday
                premiumToday
            }
            newTalents {
                _id
                firstName
                lastName
                createdAt
            }
            newJobOffers {
                _id
                title
                city
                jobNumber
                createdDate
                recruitment {
                    method
                }
            }
            newApplications {
                _id
                status
                subStatus
                date
                jobNumber
                talent {
                    _id
                    fullName
                }
                jobOffer {
                    _id
                    title
                    recruitment {
                        method
                    }
                }
            }
            newCompanies {
                _id
                commercialName
                bossFirstname
                bossLastname
                createdDate
            }
        }
    }
`;

export const GET_DASHBOARD_STATS = gql`
    query GetDashboardStats($date: Date) {
        getDashboardStats(date: $date) {
            companiesToday
            companiesTotal
            talentsToday
            talentsTotal
            jobOffersToday
            jobOffersTotal
            applicationsToday
            applicationsTotal
            offerBreakdown {
                classicToday
                classicTotal
                premiumToday
                premiumTotal
            }
            applicationBreakdown {
                classicToday
                classicTotal
                premiumToday
                premiumTotal
            }
        }
    }
`;

export const GET_DASHBOARD_NEW_TALENTS = gql`
    query GetDashboardNewTalents($limit: Int, $date: Date) {
        getDashboardNewTalents(limit: $limit, date: $date) {
            _id
            firstName
            lastName
            createdAt
            profilePicture {
                url
            }
        }
    }
`;

export const GET_DASHBOARD_NEW_COMPANIES = gql`
    query GetDashboardNewCompanies($limit: Int, $date: Date) {
        getDashboardNewCompanies(limit: $limit, date: $date) {
            _id
            commercialName
            bossFirstname
            bossLastname
            createdDate
            brandLogo {
                url
            }
        }
    }
`;

export const GET_DASHBOARD_NEW_JOB_OFFERS = gql`
    query GetDashboardNewJobOffers($limit: Int, $date: Date, $method: String) {
        getDashboardNewJobOffers(limit: $limit, date: $date, method: $method) {
            _id
            title
            city
            jobNumber
            createdDate
            recruitment {
                method
            }
            brand {
                brandLogo {
                    url
                }
            }
            pro {
                brandLogo {
                    url
                }
            }
        }
    }
`;

export const GET_DASHBOARD_NEW_APPLICATIONS = gql`
    query GetDashboardNewApplications($limit: Int, $date: Date, $method: String) {
        getDashboardNewApplications(limit: $limit, date: $date, method: $method) {
            _id
            status
            subStatus
            date
            jobNumber
            jobApplicationNumber
            talent {
                _id
                fullName
                profilePicture {
                    url
                }
            }
            jobOffer {
                _id
                title
                recruitment {
                    method
                }
                brand {
                    brandLogo {
                        url
                    }
                }
                pro {
                    brandLogo {
                        url
                    }
                }
            }
        }
    }
`;
